<template>
	<v-container fluid>
		<v-row>
			<v-col cols="12" lg="12" class="pb-0 pt-0">
				<v-card flat>
					<v-card-text class="pb-0 pt-2">
						<v-row>
							<v-col class="d-flex justify-start pa-0 pl-2">
								<v-btn color="primary" @click="addClick">
									<v-icon small>fa-plus</v-icon>&nbsp;&nbsp;{{ $t('buttons.add') }}
								</v-btn>
							</v-col>
							<v-col class="d-flex justify-center pb-0 pt-0">
								<v-card-title class="text-center pa-2 pb-2 pt-0">
									{{ $t('modules.certificates') }}</v-card-title
								>
							</v-col>
							<v-col></v-col>
						</v-row>
						<v-row>
							<v-col class="pb-0 pt-0">
								<TheTable
									:additional-filters="certificatesTable.additionalFilters"
									:default-sort="certificatesTable.defaultSort"
									:excel="true"
									:fields="certificatesTable.headers"
									:header-selection-key="'certificates-headers'"
									:height="certificatesTable.height"
									:total-records="certificatesTable.total"
									:filter-save-key="'certificates-filters'"
									@excel="excelExport"
									@headers="selectHeaders"
									@reload="reloadData"
								>
									<tr
										v-for="(item, key) in certificatesTable.items"
										:key="key"
										:class="{ 'cursor-pointer': true }"
										@contextmenu.prevent="editClick(props.item.id, true)"
									>
										<td
											v-if="certificatesTable.selectedHeaders.includes('id')"
											@click="editClick(item.id, false)"
										>
											{{ item.id }}
										</td>
										<td
											v-if="certificatesTable.selectedHeaders.includes('name')"
											@click="editClick(item.id, false)"
										>
											<b>{{ item.name }}</b>
										</td>
										<td
											v-if="certificatesTable.selectedHeaders.includes('active')"
											@click="editClick(item.id, false)"
										>
											<v-icon v-if="item.active" small>fa-check</v-icon>
										</td>
										<td>
											<v-tooltip bottom>
												<template v-slot:activator="{ on, attrs }">
													<v-btn
														icon
														small
														v-bind="attrs"
														@click="editClick(item.id, true)"
														v-on="on"
													>
														<v-icon small>fa-external-link-alt</v-icon>
													</v-btn>
												</template>
												<span>{{ $t('tooltips.openInNewTab') }}</span>
											</v-tooltip>
										</td>
									</tr>
								</TheTable>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import TheTable from '../../trinkets/TheTable';

export default {
	name: 'Certificates',
	components: { TheTable },
	data: function () {
		return {
			certificatesTable: {
				selectedHeaders: [],
				headers: [
					{ text: this.$t('fields.id'), value: 'id', type: 'string', width: '60px', allowFilter: true },
					{ text: this.$t('fields.name'), value: 'name', type: 'string', allowFilter: true },
					{
						text: this.$t('fields.active'),
						value: 'active',
						type: 'boolean',
						width: '100px',
						allowFilter: false,
					},
					{ text: '', value: 'actions', type: '', sortable: false, width: '100px', allowFilter: false },
				],
				additionalFilters: [],
				items: [],
				total: 0,
				lastRequest: null,
				height: '0px',
				defaultSort: {
					field: 'name',
					descending: true,
				},
			},
		};
	},
	methods: {
		addClick() {
			this.$router.push('/certificates/0');
		},
		editClick(id, newTab = false) {
			if (!newTab) {
				this.$router.push('/certificates/' + id);
			} else {
				let routeData = this.$router.resolve('/certificates/' + id);
				window.open(routeData.href, '_blank');
			}
		},
		selectHeaders(headers) {
			this.certificatesTable.selectedHeaders = headers;
		},
		reloadData(request) {
			this.certificatesTable.lastRequest = request;
			let vm = this;
			this.$APICall(
				'get',
				'certificates',
				request,
				(data, success) => {
					if (success) {
						vm.certificatesTable.items = data.items;
						vm.certificatesTable.total = data.total;
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				false
			);
		},
		excelExport() {
			let excelRequest = JSON.parse(JSON.stringify(this.certificatesTable.lastRequest));
			excelRequest.pagination.itemsPerPage = 999999999;
			excelRequest.pagination.page = 1;

			let vm = this;
			this.$APICall(
				'get',
				'certificates',
				excelRequest,
				(data, success) => {
					if (success) {
						vm.$APICall('post', 'excel/certificates', data.items, (data, success) => {
							window.open(data.link);
						});
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				false
			);
		},
		resolveWindowResize() {
			this.certificatesTable.height = window.innerHeight - 215 + 'px';
		},
	},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('/login');
		}

		this.$myStore.commit('setBreadcrumbs', [
			{ text: this.$t('modules.certificates'), href: '/#/certificates', disabled: true },
		]);

		window.addEventListener('resize', this.resolveWindowResize);
		this.resolveWindowResize();
	},
};
</script>

<style scoped></style>
